module.exports = __webpack_public_path__ + "static/img/stefan_skellen.02eee5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/stefan_skellen.png
// module id = G+1S
// module chunks = 0